import { dbRef } from "../../db-ref";
import { ResourceSubPipeline } from "../../utils";
import { zProfile } from "./profile-resource";

const profileUserPipeline: ResourceSubPipeline = {
  mainStages: [
    {
      $lookup: {
        from: dbRef.user.collection,
        localField: "userId",
        foreignField: "_id",
        as: "userDoc",
      },
    },
    { $unwind: "$userDoc" },
    {
      $lookup: {
        from: dbRef.role.collection,
        localField: "userDoc.roleId",
        foreignField: "_id",
        as: "userDoc.roleDoc",
      },
    },
    { $unwind: "$userDoc.roleDoc" },
  ],
  projectStage: {
    "userDoc._id": 1,
    "userDoc.firstName": 1,
    "userDoc.lastName": 1,
    "userDoc.username": 1,
    "userDoc.country": 1,
    "userDoc.profileImage": 1,

    "userDoc.roleDoc._id": 1,
    "userDoc.roleDoc.name": 1,

    "userDoc.primaryAddress": 1,
    "userDoc.billingAddress": 1,
    "userDoc.timezone": 1,

    "userDoc.email": 1,
    "userDoc.phoneNumber": 1,

    "userDoc.stripeCards": 1,
    "userDoc.stripeCustCognifleId": 1,
    "userDoc.paypalAccId": 1,

    "userDoc.isDocumentVerified": 1,

    "userDoc.membership": 1,
    "userDoc.membershipBenefits": 1,

    "userDoc.visibleOnProfile": 1,
    "userDoc.twoFactorAuth": 1,
    "userDoc.securityQuestions.Questions": 1,
    "userDoc.notificationSettings": 1,

    "userDoc.fieldUpdates": 1,
  },
};

export const profileCategoryPipeline: ResourceSubPipeline = {
  mainStages: [
    {
      $lookup: {
        from: dbRef.category.collection,
        localField: "profileCategory.id",
        foreignField: "_id",
        as: "profileCategory.categoryDoc",
      },
    },
    {
      $addFields: {
        profileCategory: {
          $cond: {
            if: { $gt: [{ $size: { $ifNull: ["$profileCategory.categoryDoc", []] } }, 0] },
            then: "$profileCategory",
            else: "$$REMOVE",
          },
        },
      },
    },
    {
      $unwind: {
        path: "$profileCategory.categoryDoc",
        preserveNullAndEmptyArrays: true,
      },
    },
    {
      $addFields: {
        "profileCategory.subCategoryDoc": {
          $cond: {
            if: {
              $ne: [{ $type: "$profileCategory.categoryDoc" }, "missing"],
            },
            then: {
              $filter: {
                input: "$profileCategory.categoryDoc.subCategory",
                as: "sub",
                cond: { $eq: ["$$sub._id", "$profileCategory.subCategoryId"] },
              },
            },
            else: "$$REMOVE",
          },
        },
      },
    },
    {
      $unwind: {
        path: "$profileCategory.subCategoryDoc",
        preserveNullAndEmptyArrays: true,
      },
    },
  ],
  projectStage: {
    profileCategory: {
      $cond: {
        if: { $ne: [{ $type: "$profileCategory.categoryDoc" }, "missing"] },
        then: "$profileCategory",
        else: "$$REMOVE",
      },
    },
  },
};

export function getProfilePipelines() {
  return {
    _z: zProfile,
    mainStages: [...profileUserPipeline.mainStages, ...profileCategoryPipeline.mainStages],
    projectStage: {
      // common
      profileType: 1,
      _id: 1,
      isOnboardingComplete: 1,
      isComplete: 1,
      selectedProfileTemplate: 1,
      primaryLocation: 1,
      languages: 1,

      updatedAt: 1,
      createdAt: 1,

      // client-company
      availableOn: 1,

      // companies-common
      companyInfo: 1,
      companyOverview: 1,

      // provider-common
      experienceLevel: 1,
      linkedAccounts: 1,

      // provider-professional
      title: 1,
      overview: 1,
      cvLink: 1,
      workHistory: 1,
      educationHistory: 1,

      // provider-business
      secondaryLocation: 1,
      trustedBy: 1,
      representativeInfo: 1,
      qualifications: 1,

      ...profileUserPipeline.projectStage,
      ...profileCategoryPipeline.projectStage,
    },
  };
}
